import styled from "styled-components";

export const AppliedFiltersBox = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    flex-wrap: wrap;

    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: -ms-autohiding-scrollbar;
    overflow: -moz-scrollbars-none;
    overflow-x: auto;
    &::-webkit-scrollbar {
        display: none;
    }
`